export default __webpack_public_path__ + "static/AppBeers13-fbe5fbc3bb47fec7af1f610700ea8e3c.png";